var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nav-menu",on:{"click":_vm.goto}},[_c('el-tooltip',{attrs:{"content":"消息"}},[_c('svg-icon',{staticClass:"nav-icon",attrs:{"icon":"icon-msg"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }